module.exports = __webpack_public_path__ + "static/media/2-Dogs-with-Red-Bows---Pastel.05c94071.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/2-Dogs-with-Red-Bows---Pastel.jpg
 ** module id = 414
 ** module chunks = 0
 **/